export default "__VITE_ASSET__BBZzGHQ6__"